import React, { useCallback, useEffect } from 'react'
import { observer } from "mobx-react-lite"

import { makeStyles } from '@mui/styles';
import Tooltip from '@mui/material/Tooltip';
import Editor from '../editor/Editor'
import { useDispatch } from 'react-redux'
import clsx from 'clsx';

import Waveform from '../../components/Waveform'
import usePlayer from '../common/usePlayer'
import StyledThemeProvider from '../../components/StyledThemeProvider'

import {ReactComponent as EditIcon} from '../../images/loop-edit.svg'
import { useTipsEditor } from './ctx'
import useWindowSize from '../../hooks/window-size';


const height = 38;
const useStyles = makeStyles({
  root: {
    position: 'relative',
    height: height,
    width: '100%',
    overflow: 'hidden',
  },
  action: {
    position: 'absolute',
    top:0,
    left:0,
    height: height,
    width: '100%',
    overflow: 'hidden',
    zIndex: 100,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    "&:hover, &.autoShow": {
      background: 'rgba(0, 0, 0, 0.12)',
      // boxShadow: '0px 6px 10px 0px rgba(0, 0, 0, 0.2)',
      borderRadius: '4px',
    },
    "&:hover .edit, &.autoShow .edit": {
      display: 'flex',
    }
  },
  editIconWrap: {
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    borderRadius: '25px',
    width: 26,
    height: 26,
    color: '#FFF',
    // display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'none',
  },
  editIcon: {
    width: 16,
    height: 16,
  },
  tooltip: {
    color: '#FF6500',
    backgroundColor: 'white',
    border: '1px solid #FF6500'
  },
  arrow: {
    color: '#FF6500'
  }
});

const TipsWrap = ({autoShow, children}) => {
  const { width } = useWindowSize()
  const classes = useStyles();
  if (autoShow && width > 760) {
    return <Tooltip open arrow placement="top" classes={{arrow: classes.arrow, tooltip: classes.tooltip}} title="Click on the waveform to edit the loop">{children}</Tooltip>
  }
  return children
}

const EditLoop = observer(({model, background, first}) => {
  const dispatch = useDispatch()
  const { volume, playType } = usePlayer()
  const classes = useStyles();
  const { canShowTips, setTipsEditor } = useTipsEditor()
  const autoShow = canShowTips && first;
  const { width } = useWindowSize()

  const onShow = (e) => {
    e.stopPropagation()
    e.nativeEvent.stopImmediatePropagation()
    model.toOpen()
    playType(null)
    if (canShowTips) {
      setTipsEditor('1')
    }
  }

  const close = (toMyLoops) => {
    model.toClose()
    toMyLoops && model.parent.toMyLoops()
  }

  useEffect(() => {
    model.setDispatch(dispatch)
    return () => {
      model.setDispatch(null)
    }
  }, [dispatch])

  useEffect(() => {
    model.loadJson()
  }, [model])

  const ready = useCallback((wave) => {
    if (wave) {
      wave.on('play', () => playType('loop'))
    }
    model.setWave(wave)
  }, [model])
  
  if (model.loading || model.json === null) {
    return null;
  }
  return <div className={classes.root} onClick={(e) => e.stopPropagation()}>
    <Waveform height={height} url={model.url} data={model.json?.thumbnail} volume={volume} background={background} ready={ready} />
    <TipsWrap autoShow={autoShow}>
    <div className={clsx(classes.action, autoShow && 'autoShow')} onClick={onShow} style={{display: !model.canEdit ? 'none' : ''}}>
      <div className={clsx(classes.editIconWrap, 'edit')}>
        <EditIcon className={classes.editIcon} />
      </div>
    </div>
    </TipsWrap>
    {!model.loading ? <StyledThemeProvider scope="editor">{<Editor open={model.open} 
        onClose={close} id={model.id} name={model.name} 
        packId={model.packId} 
        parentId={model.parentId} 
        preview={model.preview}
        url={model.url} 
        alreadyAdd={model.alreadyAdd} 
        editOwnLoop={model.isMy} />}</StyledThemeProvider> : null}
  </div>
})

export default EditLoop